import React, { useState } from 'react'
import PaymentApproval from '../../../vendorManagement/admission-advisor-dashboard/PaymentApproval'
import { useWizard } from "components/wizard/WizardContext";


const PaymentApprovalWithActions = (props) => {

    const { setSearchWizard, next } = useWizard();
    const [showActions, setShowActions] = useState(false);

    const handleRaisePaymentRequest = () => {
        if (!showActions) {
            setSearchWizard((prev) => ({
                ...prev,
                isShow: false,
            }));
            next(0);
        }
    };

    return (
        <PaymentApproval {...props} showApproverActions={showActions} handleRaisePaymentRequest={handleRaisePaymentRequest} />
    )
}

export default PaymentApprovalWithActions